/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PollOption } from './PollOption';
/**
 * Anonymous voter view of the current question. open=false → wait for the presenter.
 */
export type PollPublicState = {
    joinCode?: string;
    open?: boolean;
    sessionId?: string;
    questionId?: string;
    question?: string;
    qtype?: PollPublicState.qtype;
    kind?: PollPublicState.kind;
    /**
     * '' (bars) | spectrum | rating | reactions.
     */
    display?: string;
    labels?: Array<string>;
    options?: Array<PollOption>;
};
export namespace PollPublicState {
    export enum qtype {
        SINGLE = 'single',
        MULTI = 'multi',
    }
    export enum kind {
        POLL = 'poll',
        WORDCLOUD = 'wordcloud',
        QA = 'qa',
    }
}

